module.exports = __webpack_public_path__ + "img/Comic01-3.d894472f.png";